import styled from 'styled-components';
import UsernameInput from './UsernameInput';

export default styled(UsernameInput)`
  width: 100%;
  .username-input {
    display: flex;

    &__input {
      margin-bottom: ${props => (props.error ? '0' : '1rem')};
      width: 100%;

      input {
        height: 48px;
      }
    }
  }
`;
